<div class="hf-first-content-container container">
  <h2>Credits</h2>
  <markdown [data]="licenseContent"></markdown>
</div>
